import { productFrames } from './rr-product-render-frame.js';

export function handZoomScale() {
  return 1.11321;
}

if (typeof window !== 'undefined' && !customElements.get('rr-product-hand-zoom')) {
  customElements.define('rr-product-hand-zoom', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = null;
      this.active = false;
      this.lastScale = null;
      this.lastInset = null;
      const options = { passive: true, signal: this.abort.signal };
      this.queue = () => {
        if (!this.active || this.frame !== null) return;
        this.frame = productFrames.read(() => {
          this.frame = null;
          if (!this.isConnected) return;
          const inset = this.parentElement.getBoundingClientRect().left;
          const scale = handZoomScale();
          if (scale === this.lastScale && inset === this.lastInset) return;
          return () => {
            this.lastScale = scale;
            this.lastInset = inset;
            this.style.setProperty('--rr-hand-left-inset', `${inset}px`);
            this.style.setProperty('--rr-hand-scale', String(scale));
          };
        });
      };
      this.observer = new IntersectionObserver(entries => {
        this.active = entries[0].isIntersecting;
        this.toggleAttribute('data-active', this.active && !this.reduced.matches);
        this.queue();
      }, { rootMargin: '100px 0px' });
      this.observer.observe(this);
      this.resize = new ResizeObserver(this.queue);
      this.resize.observe(this);
      window.addEventListener('scroll', this.queue, options);
      window.addEventListener('resize', this.queue, options);
      window.addEventListener('pageshow', this.queue, options);
      document.addEventListener('rr:details-layout-settled', this.queue, options);
      this.reduced.addEventListener('change', () => {
        this.toggleAttribute('data-active', this.active && !this.reduced.matches);
        this.queue();
      }, options);
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.resize?.disconnect();
      if (this.frame !== null) productFrames.cancel(this.frame);
      this.frame = null;
    }
  });
}
